import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Products from './components/Products';
import Cells from './components/Cells';
import CellsByket from './components/CellsByket'
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';

const App = () => {
  return (
    <Router>
      <div className="d-flex">
        <Navbar />
        <div className="flex-grow-1">
          <Routes>
            {/* Открытый маршрут для логина */}
            <Route path="/login" element={<Login />} />
            {/* Защищённые маршруты */}
            <Route
              path="/products"
              element={
                <PrivateRoute>
                  <Products />
                </PrivateRoute>
              }
            />
            <Route
              path="/cells"
              element={
                <PrivateRoute>
                  <Cells />
                </PrivateRoute>
              }
            />
            <Route
              path="/bykets"
              element={
                <PrivateRoute>
                  <CellsByket />
                </PrivateRoute>
              }
            />
            {/* Редирект всех неизвестных маршрутов на /products (можно изменить по необходимости) */}
            <Route
              path="*"
              element={
                <PrivateRoute>
                  <Products />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
